import React from "react";
import _ from "underscore";
import BottomNavigation, {
  BottomNavigationAction
} from "material-ui/BottomNavigation";
import { Button, Paper } from "material-ui";
import { withStyles } from "material-ui/styles";
import EditAttrModalContainer from "containers/SetupAttr/EditAttrModalContainer";
import { convertLocaleKeyToName } from "utils/formatter";
import CInput from "uis/CInput";
import CTooltips from "uis/CTooltips";
import Container from "./Container";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100,
    height: 680,
    position: "relative"
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0,
    flex: 1,
    color: "#575962"
  },
  main: {
    padding: 20
  },
  subTitle: {
    color: "#575962",
    display: "inline-block",
    width: 150,
    marginRight: 50
  },
  paperDesc: {
    color: "#9699a2",
    fontSize: "1rem",
    fontWeight: 300,
    marginBottom: 5
  },
  buttons: {
    position: "absolute",
    right: 40,
    left: 40,
    bottom: 20
  },
  clear: {
    clear: "both"
  },
  cancelBtn: {
    marginRight: 10
  },
  actionBtn: {
    marginRight: 10,
    width: 225
  }
});

class SetupAttr extends React.Component {
  componentWillMount() {
    this.props.fetchAttrDetail();
    window.scroll(0, 0);
  }
  naviStyle(localeNo) {
    return this.props.setupAttr.localeNo === localeNo
      ? { color: "#fff", backgroundColor: "#26a69a" }
      : { color: "#333", backgroundColor: "transparent" };
  }

  render() {
    const { classes, setupAttr, changeUseAttrs } = this.props;

    return (
      <Paper className={classes.container}>
        <EditAttrModalContainer />
        <div className={classes.header}>
          <h2 className={classes.title}>属性設定</h2>
        </div>

        <div className={classes.main}>
          <Paper style={{ marginBottom: 20, height: 560 }}>
            {/* 言語タブ */}
            <div>
              <BottomNavigation
                style={{ justifyContent: "left" }}
                value={setupAttr.localeNo}
                onChange={this.props.changeLocale}
                showLabels
              >
                {_.map(setupAttr.locales, locale => (
                  <BottomNavigationAction
                    key={locale}
                    style={this.naviStyle(locale)}
                    value={locale}
                    label={convertLocaleKeyToName(locale)}
                  />
                ))}
              </BottomNavigation>
            </div>

            <div>
              <div style={{ padding: 20 }}>
                <div>
                  <div className={classes.paperDesc}>
                    <CTooltips
                      text="属性回答方法の説明"
                      title="属性の回答について補足する文言が必要であれば記入してください。"
                      placement="right"
                      style={{
                        backgroundColor: "white"
                      }}
                    />
                  </div>
                </div>
                <div
                  className={classes.paperPeriod}
                  style={{ marginBottom: 20 }}
                >
                  <CInput
                    multiline
                    fullWidth
                    rows="3"
                    inputProps={{ maxLength: 1000 }}
                    value={setupAttr.answerMethods[setupAttr.localeNo]}
                    onChange={e =>
                      this.props.changeItem("answerMethods", e.target.value)
                    }
                  />
                </div>
                <div>
                  <div className={classes.paperDesc}>属性一覧</div>
                </div>
                <div
                  style={{
                    padding: 10,
                    border: "1px solid darkgrey",
                    overflowY: "scroll",
                    height: 320
                  }}
                >
                  <Container
                    {...setupAttr}
                    changeUseAttrs={changeUseAttrs}
                    addNewItem={this.props.addNewItem}
                    changeAttrOrder={this.props.changeAttrOrder}
                    removeAttr={this.props.removeAttr}
                    openEditAttrModal={this.props.openEditAttrModal}
                  />
                </div>
              </div>
            </div>
          </Paper>
        </div>
        <div className={classes.buttons}>
          <div style={{ textAlign: "center" }}>
            <div>
              <Button
                style={{ froat: "left" }}
                raised
                className={classes.cancelBtn}
                onClick={() =>
                  (this.props.history.length === 1
                    ? window.close()
                    : this.props.history.goBack())
                }
              >
                閉じる
              </Button>
              <Button
                raised
                onClick={() => {
                  this.props.handleUpdate(setupAttr);
                }}
              >
                更新
              </Button>
            </div>
          </div>
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(SetupAttr);



// WEBPACK FOOTER //
// ./src/components/SetupAttr/index.jsx